import React from 'react';

import { Row } from '../Layout/Grid';

const Spinner = require('react-spinkit');

const Loading: React.FC<{ size?: number; onlySpinner?: boolean; }> = (props) => {
  const { onlySpinner, size } = props;

  return onlySpinner ? (
    <Spinner
      fadeIn="none"
      name="circle"
      color="#0E4C54"
      style={{
        height: size || undefined,
        width: size || undefined,
      }}
    />
  ) : (
      <>
        <Row
          className="absolute top-0 bottom-0 left-0 right-0 align-center justify-center"
          style={{ filter: 'blur(5px)', background: '#fff9', zIndex: 9 }}
        />
        <Row
          className="absolute top-0 bottom-0 left-0 right-0 align-center justify-center"
          style={{ background: 'none', zIndex: 10 }}
        >
          <Spinner
            fadeIn="none"
            name="circle"
            color="#0E4C54"
            style={{
              height: size || undefined,
              width: size || undefined,
            }}
          />
        </Row>
      </>
    );
};
export default Loading;
